import { Close } from "@mui/icons-material";
import { Box, TextField, Drawer } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledDrawer = styled(Drawer)(({ theme }) => ({
  "& .MuiDrawer-paper": {
    width: "100%",
    height: "100%",
    backgroundColor: theme.palette.surface.bg,
    color: theme.palette.text.primary,
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
  },
}));

export const StyledSearchBarWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  padding: "19px 25px",
  backgroundColor: theme.palette.surface.container,
}));

export const StyledCloseButton = styled(Close)(({ theme }) => ({
  cursor: "pointer",
}));

export const StyledTextField = styled(TextField)(({ theme }) => ({
  backgroundColor: theme.palette.surface.container,
  borderRadius: "12px",
  width: "100%",

  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },

  "& .MuiSelect-icon": {
    color: theme.palette.text.secondary,
    fontSize: "24px",
  },

  "& .MuiInputBase-input": {
    padding: "8px",
    ...theme.typography["body-md"],

    "&::placeholder": {
      color: theme.palette.text.secondary,
    },
  },

  "& .MuiSvgIcon-root": {
    color: theme.palette.text.secondary,
  },
}));
